<template>
  <div class="section">
    <h3 class="black medium" v-if="$slots.title">
      <slot name="title"></slot>
    </h3>
    <div class="black regular">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style>
  .section > h3 {
    font-size: 16px;
    padding-bottom: 8px;
  }

  .section > div {
    font-size: 14px;
    line-height: 1.36;
  }
</style>
